import absoluteUrl from './absoluteUrl';
import addAccessors from './addAccessors';
import b64toBlob from './b64toBlob';
import debounce from './debounce';
import downloadCSVReport from './downloadCSVReport';
import { formatDate, formatDateTime } from './formatDate';
import formatPN from './formatPN';
import formatTime from './formatTime';
import generateAcceptHeader from './generateAcceptHeader';
import getActiveViewportModality from './getActiveViewportModality';
import { getSelectedButtonSection } from './getSelectedButtonSection';
import guid from './guid';
import hierarchicalListUtils from './hierarchicalListUtils';
import hotkeys from './hotkeys';
import imageIdToURI from './imageIdToURI';
import isDicomUid from './isDicomUid';
import isDisplaySetReconstructable from './isDisplaySetReconstructable';
import isEqualWithin from './isEqualWithin';
import { isImage } from './isImage';
import isLowPriorityModality from './isLowPriorityModality';
import isMobileDevice from './isMobileDevice';
import makeCancelable from './makeCancelable';
import makeDeferred from './makeDeferred';
import ObjectPath from './objectPath';
import progressTrackingUtils from './progressTrackingUtils';
import Queue from './Queue';
import resolveObjectPath from './resolveObjectPath';
import roundNumber from './roundNumber';
import sopClassDictionary from './sopClassDictionary';
import sortBy from './sortBy';
import sortInstancesByPosition from './sortInstancesByPosition';
import { seriesSortCriteria, sortingCriteria, sortStudy, sortStudyInstances, sortStudySeries } from './sortStudy';
import { getSplitParam, splitComma } from './splitComma';
import urlUtil from './urlUtil';
import writeScript from './writeScript';

export * from './isDisplaySetReconstructable';

// Commented out unused functionality.
// Need to implement new mechanism for derived displaySets using the displaySetManager.

const utils = {
	addAccessors,
	guid,
	ObjectPath,
	absoluteUrl,
	sortBy,
	sortBySeriesDate: sortStudySeries,
	sortStudy,
	sortStudySeries,
	sortStudyInstances,
	sortingCriteria,
	seriesSortCriteria,
	writeScript,
	formatDate,
	formatDateTime,
	formatPN,
	formatTime,
	isMobileDevice,
	b64toBlob,
	urlUtil,
	imageIdToURI,
	//loadAndCacheDerivedDisplaySets,
	makeDeferred,
	makeCancelable,
	hotkeys,
	Queue,
	isDicomUid,
	isEqualWithin,
	resolveObjectPath,
	hierarchicalListUtils,
	progressTrackingUtils,
	isLowPriorityModality,
	isImage,
	isDisplaySetReconstructable,
	debounce,
	roundNumber,
	downloadCSVReport,
	splitComma,
	getSplitParam,
	generateAcceptHeader,
	sopClassDictionary,
	getSelectedButtonSection,
	getActiveViewportModality,
};

export {
	ObjectPath,
	Queue,
	absoluteUrl,
	b64toBlob,
	debounce,
	downloadCSVReport,
	formatDate,
	formatDateTime,
	generateAcceptHeader,
	getSplitParam,
	guid,
	hierarchicalListUtils,
	hotkeys,
	imageIdToURI,
	isDicomUid,
	isDisplaySetReconstructable,
	isEqualWithin,
	isImage,
	isLowPriorityModality,
	makeCancelable,
	//loadAndCacheDerivedDisplaySets,
	makeDeferred,
	progressTrackingUtils,
	resolveObjectPath,
	roundNumber,
	sopClassDictionary,
	sortBy,
	sortInstancesByPosition,
	splitComma,
	urlUtil,
	writeScript,
};

export default utils;
